export const NAME = 'MultiFlightTracker';



// WEBPACK FOOTER //
// ./modules/MultiFlight/redux/constants.js